import { v4 } from 'uuid';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const createStyleTag = /* @__PURE__ */ __name((styles) => {
  if (!document) {
    return;
  }
  const style = document.createElement("style");
  style.id = v4();
  document.head.append(style);
  if (styles) {
    style.innerHTML = styles;
  }
  return style;
}, "createStyleTag");

export { createStyleTag };
//# sourceMappingURL=create-style-tag.js.map
